import { Cartao } from '../../../components/ListaDeDados'
import { dataHora } from '../../../lib/datas'
import { ROTULO_EFEITO_DA_CARGA, ROTULO_ORIGEM_CHAMADO } from '../../../lib/glossario'
import type { CargaQueTrouxe } from '../../../types/chamado'

/**
 * As cargas que passaram por este chamado, da mais recente para a mais antiga.
 *
 * É a trilha de procedência do registro, e ela responde a pergunta que aparece quando duas fontes
 * discordam: de qual arquivo, e de qual instante, veio o valor que está na tela. Medido: a planilha
 * da fiscalização diz que o chamado 2026050648 fechou em 29/05 com prazo estourado, e a base do
 * e-Niterói diz que ele está pendente. As duas estão certas no seu instante — e sem esta lista não
 * há como saber qual instante produziu o que se está lendo.
 *
 * `coletadoEm` é o instante a que o CONTEÚDO se refere, não o do envio. A diferença é o motivo de a
 * linha trazer as duas datas: uma carga feita em agosto com a planilha de maio sabe de maio.
 *
 * @param props as cargas do chamado
 * @returns o cartão da trilha de cargas
 */
export function CargasDoChamado({ cargas }: { cargas: CargaQueTrouxe[] }) {
  if (cargas.length === 0) {
    return null
  }

  return (
    <Cartao titulo="De onde este registro veio" descricao="As cargas que trouxeram ou atualizaram este chamado.">
      <ul className="space-y-3">
        {cargas.map((carga) => (
          <li key={`${carga.importacaoId}-${carga.iniciadoEm}`} className="text-sm">
            <p className="font-medium text-slate-900">{carga.arquivo}</p>
            <p className="mt-0.5 text-xs text-slate-600">
              {ROTULO_EFEITO_DA_CARGA[carga.efeito] ?? carga.efeito} ·{' '}
              {ROTULO_ORIGEM_CHAMADO[carga.origem] ?? carga.origem}
            </p>
            <p className="mt-0.5 text-xs text-slate-600">
              Dado referente a <span className="font-medium">{dataHora(carga.coletadoEm)}</span> · carregado em{' '}
              {dataHora(carga.iniciadoEm)}
            </p>
          </li>
        ))}
      </ul>
    </Cartao>
  )
}
